// Exposes the Store Action redesign widget with its query and error-boundary infrastructure.
import React from 'react';

import { StoreActionActiveList } from './StoreActionActiveList';
import { StoreActionFeatureBoundary } from './StoreActionFeatureBoundary';
import { getStoreActionMessage } from './storeActionLocalization';
import { STORE_ACTION_THEME_CSS_VARIABLES } from './storeActionTheme';

type StoreActionProps = {
  readonly storeActionItem: string;
};

const isValidStoreNumber = (
  storeNumber: string | null
): storeNumber is string =>
  Boolean(
    storeNumber &&
      storeNumber.trim() &&
      storeNumber !== 'null' &&
      storeNumber !== 'undefined'
  );

const StoreAction: React.FC<StoreActionProps> = ({ storeActionItem }) => {
  if (storeActionItem !== '1') {
    return null;
  }

  const storeNumber = window.sessionStorage.getItem('storeNumber');

  if (!isValidStoreNumber(storeNumber)) {
    return <div role="status">{getStoreActionMessage('unavailable')}</div>;
  }

  return (
    <div style={{ ...STORE_ACTION_THEME_CSS_VARIABLES, margin: '0 7px' }}>
      <StoreActionFeatureBoundary>
        <StoreActionActiveList storeNumber={storeNumber} />
      </StoreActionFeatureBoundary>
    </div>
  );
};

export default StoreAction;
